import ncDialogReducer from './ncDialogReducer';

export default ncDialogReducer;